// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import moment from 'moment';
import assign from 'es6-object-assign';
import promise from 'es6-promise';
import VueCookie from 'vue-cookie';
import VueCarousel from 'vue-carousel';
import App from './App';
import router from './router';
import './common.css';

assign.polyfill();
promise.polyfill();

Vue.use(VueCookie);
Vue.use(VueCarousel);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  filters: {
    dateFormate(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
  },
});



// WEBPACK FOOTER //
// ./src/main.js